<template>
    <div>
      <el-card class="box-card">
        <el-form :model="editDevice" ref="editDeviceRef" label-width="75px">
          <el-form-item label="归属机构" class="addAdminForm">
            <Rsljigou :propsjigouid="editDevice.jigouid" :propsjigouname="editDevice.jigouname" @change="changeRsljigou"></Rsljigou>
          </el-form-item>
          <el-form-item label="保修卡号" class="addAdminForm">
            <el-input v-model="editDevice.sn" placeholder="请输入保修卡号"></el-input>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clicksave">保存</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
</template>

<script>
import Rsljigou from '@/components/Rsljigou.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    Rsljigou
  },
  data () {
    return {
      editDevice: {
        id: '',
        jigouid: '0',
        jigouname: '',
        sn: ''
      }
    }
  },
  mounted () {
  },
  methods: {
    LoadData (row) {
      console.log(row)
      this.editDevice.id = row.Id
      this.editDevice.jigouid = row.Jigouid.toString()
      this.editDevice.jigouname = row.Jigouname
      this.editDevice.sn = row.Sn
    },
    clickreturn () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.apiEditRefractiveDiscrepancyDevice()
    },
    changeRsljigou (vid, vname) {
      this.editDevice.jigouid = vid
      this.editDevice.jigouname = vname
    },
    apiEditRefractiveDiscrepancyDevice: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: that.editDevice.id,
        jigouid: that.editDevice.jigouid,
        sn: that.editDevice.sn
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditRefractiveDiscrepancyDevice, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 365px;
}
</style>
